import React, { Component } from 'react';
import { FormGroup, FormControl, ControlLabel, Col, Checkbox } from 'react-bootstrap';
import Api from './../../../Global/Modules/Api'
import { Container, Dropdown } from 'semantic-ui-react'
import _isEqual from 'lodash/isEqual';



class BedrijfsGegevens extends Component {
    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
        this.handleChange2 = this.handleChange2.bind(this)
        this.state = {
            visible: "block",
            Comps: []
        }
    }
    componentWillReceiveProps(nextProps) {
        if (!_isEqual(nextProps, this.props.data)) {
            let d = nextProps;
            if (d && d.data && d.data.companies) {
                let comps = d.data.companies.map(function (item, index) {
                    return { key: item.id, value: item.id, text: item.name, id: item.id }
                })
                this.setState({ Comps: [...[{ key: '0', value: '0', text: 'Overig', id: '0' }], ...comps] })
                if (d.data.companyId != 0) {
                    this.setState({
                        visible: "none"
                    });
                }
            }
        }
    }
    handleChange(event) {

        const target = event.target
        const isCheckbox = target.type === "checkbox"
        const name = target.name
        isCheckbox ? this.props.onChange(name, target.checked) : this.props.onChange(name, target.value)
    }
    handleChange2(event, value) {
        const target = value
        const name = target.name
        if (target.value != 0) {
            this.setState({
                visible: "none"
            });
        } else {
            this.setState({
                visible: "block"
            });
        }
        this.props.onChange(name, target.value);
    }

    render() {
        const data = this.props.data
        const errors = this.props.errors
        const styleLink = document.createElement("link");
        styleLink.rel = "stylesheet";
        styleLink.href =
            "https://cdn.jsdelivr.net/npm/semantic-ui/dist/semantic.min.css";
        document.head.appendChild(styleLink);
        return (
            <div>
                {/*
                    TODO: For all adresses: Add postcode + nr check and autofill address, this should not add to addresses outside netherlands.
                */}
                <h5>Bedrijfsgegevens</h5>

                <FormGroup controlId="AccountBedrijfId">
                    <Col componentClass={ControlLabel} sm={12} style={{ textAlign: "left" }}>Selecteer uw werkgever uit het dropdown menu. Zit het bedrijf er niet tussen, kies dan voor overig en vul de bedrijfsgegevens in.</Col>
                    <Col componentClass={ControlLabel} sm={4}>Bedrijf</Col>
                    <Col componentClass={ControlLabel} sm={6}>
                        <Container style={{ "padding": "0px" }}><Dropdown className="form-control"
                            search
                            selection
                            name='companyId' value={data.companyId}
                            onChange={this.handleChange2}
                            options={this.state.Comps}
                        /></Container>

                    </Col>
                </FormGroup>
                <FormGroup controlId="AccountBedrijfBuitenland" style={{ display: this.state.visible }}>
                    <Col componentClass={ControlLabel} sm={4}>
                        Buitenland
                    </Col>
                    <Col sm={6}>
                        <Checkbox name="showCompanyCountry" checked={data.companyCountry != null} onChange={this.handleChange}>Werkachtig buiten Nederland</Checkbox>
                        {data.companyCountry ?
                            <FormControl componentClass="select" name="companyCountry" value={data.companyCountry} onChange={this.handleChange}>
                                <option value="1">België</option>
                                <option value="2">Nederlandse Antillen</option>
                                <option value="3">Suriname</option>
                            </FormControl> : null}
                    </Col>

                </FormGroup>
                <FormGroup controlId="AccountBedrijfsnaam" style={{ display: this.state.visible }}>
                    <Col componentClass={ControlLabel} sm={4}>
                        Bedrijfsnaam
                </Col>
                    <Col sm={6}>
                        <FormControl value={data.company} type="text" name="company" onChange={this.handleChange} />
                        {Api.showError(errors, "company")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountBedrijfAdres" style={{ display: this.state.visible }}>
                    <Col componentClass={ControlLabel} sm={4}>
                        Adres
                </Col>
                    <Col sm={6}>
                        <FormControl value={data.companyAddress} type="text" name="companyAddress" onChange={this.handleChange} />
                        {Api.showError(errors, "companyAddress")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountBedrijfPostcode" style={{ display: this.state.visible }}>
                    <Col componentClass={ControlLabel} sm={4}>
                        Postcode
                </Col>
                    <Col sm={6}>
                        <FormControl value={data.companyPostCode} type="text" name="companyPostCode" onChange={this.handleChange} />
                        {Api.showError(errors, "companyPostCode")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountBedrijfPlaats" style={{ display: this.state.visible }}>
                    <Col componentClass={ControlLabel} sm={4}>
                        Plaats
                </Col>
                    <Col sm={6}>
                        <FormControl value={data.companyCity} type="text" name="companyCity" onChange={this.handleChange} />
                        {Api.showError(errors, "companyCity")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountBedrijfTelefoon" style={{ display: this.state.visible }}>
                    <Col componentClass={ControlLabel} sm={4}>
                        Telefoon Bedrijf
                </Col>
                    <Col sm={6}>
                        <FormControl value={data.companyPhone} type="text" name="companyPhone" onChange={this.handleChange} />
                        {Api.showError(errors, "companyPhone")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountBedrijfWebsite" style={{ display: this.state.visible }}>
                    <Col componentClass={ControlLabel} sm={4}>
                        Website
                </Col>
                    <Col sm={6}>
                        <FormControl value={data.companyWebsite} type="text" name="companyWebsite" onChange={this.handleChange} />
                        {Api.showError(errors, "companyWebsite")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountBedrijfToestemming">
                    <Col componentClass={ControlLabel} sm={4}>
                        Toestemming
                </Col>
                    <Col sm={6}>
                        <Checkbox name="companySearchable" checked={data.companySearchable} onChange={this.handleChange}>Ik ga akkoord dat mijn werkgever/bedrijf vindbaar is via de site van het Constructeursregister onder “Zoek bedrijf met een RC/RO/RT”. </Checkbox>
                    </Col>
                </FormGroup>

                <FormGroup controlId="AccountBedrijf">
                    <Col componentClass={ControlLabel} sm={4}>
                        Uw functie
                </Col>
                    <Col sm={6}>
                        <FormControl value={data.function} type="text" name="function" onChange={this.handleChange} />
                        {Api.showError(errors, "function")}
                    </Col>
                </FormGroup>

            </div>
        );
    }
}

export default BedrijfsGegevens;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Account/BedrijfsGegevens.js